import {
  Autocomplete,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import Swal from "sweetalert2";
import api from "../../../../components/services/api";
import AddIcon from "@mui/icons-material/Add";
import { DesktopDatePicker } from "@mui/lab";
import { useHistory, useParams } from "react-router";
import { Formik } from "formik";
export default function Docment() {
  const { id } = useParams();
  const history = useHistory();

  const [diremark, setDiremark] = useState(false);
  const [remarklog, setremarkLog] = useState("");
  const [remarkType, setremarkType] = useState("");

  const [log_data, setLogData] = useState([]);
  const [value, setValue] = useState("");
  const [option, setOption] = useState([]);
  const [co, setCo] = useState([]);
  const UserEmpId = localStorage.getItem("EmpId");
  const [open, setOpen] = useState(false);
  const [openphyto, setOpenphyto] = useState(false);
  const [openAmendment, setOpenAmendment] = useState(false);
  const [dateSi, setdateSi] = useState(null);
  const [timeSi, settimeSi] = useState("");
  const [datephyto, setphyto] = useState(null);
  const [timephyto, settimephyto] = useState("");
  const [Receivetime, setReceivetime] = useState("");
  const [Receivedete, setReceivedate] = useState(null);
  const [ReceivetimeSI, setReceivetimeSI] = useState("");
  const [ReceivedeteSI, setReceivedateSI] = useState(null);
  const [receiveSI, setreceiveSI] = useState([]);
  const [receive, setreceive] = useState([]);
  const [receivept, setreceivept] = useState([]);
  const [itemId, setItemID] = useState(null);
  const [doc, setDoc] = useState();
  const handleCloseremark = () => {
    setDiremark(false);
    setremarkLog("");
    setremarkType("");
  };
  const getDoc = async () => {
    try {
      const data = await api.get(`api/saleorder/detail/document/${id}`);
      setDoc(data?.data);
      setreceiveSI(
        data?.data?.DraftSI?.map((x) => ({
          Receivetime: x?.ReceiveTime,
          Receivedete: x?.ReceiveDate,
        }))
      );
      setreceive(
        data?.data?.DraftBL?.map((x) => ({
          datephyto: x?.ReceiveDate,
          timephyto: x?.ReceiveTime,
          Receivetime: x?.ReviseTime,
          Receivedete: x?.ReviseDate,
        }))
      );
      setreceivept(
        data?.data?.DraftPhyto?.map((x) => ({
          datephyto: x?.ReceiveDate,
          timephyto: x?.ReceiveTime,
          Receivetime: x?.ReviseTime,
          Receivedete: x?.ReviseDate,
        }))
      );
      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getDoc();
  }, []);
  const handleCloseSI = () => {
    setOpenAmendment(false);
    setReceivedateSI(null);
    setReceivetimeSI("");
    setItemID(null);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenphyto(false);
    setReceivedate(null);
    setReceivetime("");
    settimeSi("");
    setdateSi(null);
    setphyto(null);
    settimephyto("");
    setItemID(null);
  };
  const delete_SI = (data) => {
    receiveSI.splice(data, 1);
    setreceiveSI([...receiveSI]);
  };
  const delete_mt_stel = (data) => {
    receive.splice(data, 1);
    setreceive([...receive]);
  };
  const deletephyto = (data) => {
    receivept.splice(data, 1);
    setreceivept([...receivept]);
  };
  const handleaddpt = () => {
    const data = {
      datephyto: datephyto,
      timephyto: timephyto,
      Receivetime: Receivetime,
      Receivedete: Receivedete,
    };
    if (itemId !== null) {
      receivept?.map((x, i) => {
        if (i === itemId) {
          // return {
          x.datephyto = datephyto;
          x.timephyto = timephyto;
          x.Receivetime = Receivetime;
          x.Receivedete = Receivedete;
          // }
        }
        // console.log(Station);
        setreceivept([...receivept]);
      });
    } else {
      setreceivept([...receivept, data]);
    }
    setphyto(null);
    settimephyto("");
    setOpenphyto(false);
    setReceivedate(null);
    setReceivetime("");

    setItemID(null);
  };
  const handleEditPT = (data) => {
    setOpenphyto(true);

    setReceivedateSI(data?.Receivedete);
    setReceivetime(data?.Receivetime);
    setItemID(data.id);
  };
  const handleadd = () => {
    const data = {
      dateSi: dateSi,
      timeSi: timeSi,
      Receivetime: Receivetime,
      Receivedete: Receivedete,
    };
    if (itemId !== null) {
      receive?.map((x, i) => {
        if (i === itemId) {
          // return {
          x.dateSi = dateSi;
          x.timeSi = timeSi;
          x.Receivetime = Receivetime;
          x.Receivedete = Receivedete;
          // }
        }
        // console.log(Station);
        setreceive([...receive]);
      });
    } else {
      setreceive([...receive, data]);
    }

    setOpen(false);
    setReceivedate(null);
    setReceivetime("");
    settimeSi("");
    setdateSi(null);
    setItemID(null);
  };
  const handleaddSi = () => {
    const data = {
      Receivetime: ReceivetimeSI,
      Receivedete: ReceivedeteSI,
    };
    if (itemId !== null) {
      receiveSI?.map((x, i) => {
        if (i === itemId) {
          // return {

          x.Receivetime = ReceivetimeSI;
          x.Receivedete = ReceivedeteSI;
          // }
        }
        // console.log(Station);
        setreceiveSI([...receiveSI]);
      });
    } else {
      setreceiveSI([...receiveSI, data]);
    }

    setOpenAmendment(false);
    setReceivedateSI(null);
    setReceivetimeSI("");
    setItemID(null);
  };
  const handleEdit = (data) => {
    setOpen(true);

    setReceivedate(data?.Receivedete);
    setReceivetime(data?.Receivetime);
    settimeSi(data?.timeSi);
    setdateSi(data?.dateSi);
    setItemID(data.id);
  };
  const handleEditSI = (data) => {
    setOpenAmendment(true);

    setReceivedateSI(data?.Receivedete);
    setReceivetimeSI(data?.Receivetime);
    setItemID(data.id);
  };
  return (
    <Box>
      <Formik
        enableReinitialize
        initialValues={{
          DocumentStatus: doc?.DocumentStatus ? doc?.DocumentStatus : "",
          ReceiveSIDate: doc?.ReceiveSIDate ? doc?.ReceiveSIDate : null,
          ReceiveSITime: doc?.ReceiveSITime ? doc?.ReceiveSITime : null,
          ReviseSIDate: doc?.ReviseSIDate ? doc?.ReviseSIDate : null,
          ReviseSITime: doc?.ReviseSITime ? doc?.ReviseSITime : null,
          SubmitSIDate: doc?.SubmitSIDate ? doc?.SubmitSIDate : null,
          SubmitSITime: doc?.SubmitSITime ? doc?.SubmitSITime : null,
          // DraftSI: receivept,
          //  [
          //   {
          //     ReceiveDate: null,
          //     ReceiveTime: null,
          //     ReviseDate: null,
          //     ReviseTime: null
          //   }
          // ],
          ConfirmSIDate: doc?.ConfirmSIDate ? doc?.ConfirmSIDate : null,
          ConfirmSITime: doc?.ConfirmSITime ? doc?.ConfirmSITime : null,
          SubmitPhytoDate: doc?.SubmitPhytoDate ? doc?.SubmitPhytoDate : null,
          SubmitPhytoTime: doc?.SubmitPhytoTime ? doc?.SubmitPhytoTime : null,
          // DraftPhyto: [
          //   {
          //     ReceiveDate: null,
          //     ReceiveTime: null,
          //     ReviseDate: null,
          //     ReviseTime: null
          //   }
          // ],
          ConfirmPhytoDate: doc?.ConfirmPhytoDate
            ? doc?.ConfirmPhytoDate
            : null,
          ConfirmPhytoTime: doc?.ConfirmPhytoTime
            ? doc?.ConfirmPhytoTime
            : null,
          ReceiveInvoiceDate: doc?.ReceiveInvoiceDate
            ? doc?.ReceiveInvoiceDate
            : null,
          ReceiveInvoiceTime: doc?.ReceiveInvoiceTime
            ? doc?.ReceiveInvoiceTime
            : null,
          SendInvoiceToAccountingDate: doc?.SendInvoiceToAccountingDate
            ? doc?.SendInvoiceToAccountingDate
            : null,
          SendInvoiceToAccountingTime: doc?.SendInvoiceToAccountingTime
            ? doc?.SendInvoiceToAccountingTime
            : null,
          PickupBLDate: doc?.PickupBLDate ? doc?.PickupBLDate : null,
          PickupBLTime: doc?.PickupBLTime ? doc?.PickupBLTime : null,
          ReceiveBLDate: doc?.ReceiveBLDate ? doc?.ReceiveBLDate : null,
          ReceiveBLTime: doc?.ReceiveBLTime ? doc?.ReceiveBLTime : null,
          SendBLToCustomerDate: doc?.SendBLToCustomerDate
            ? doc?.SendBLToCustomerDate
            : null,
          SendBLToCustomerTime: doc?.SendBLToCustomerTime
            ? doc?.SendBLToCustomerTime
            : null,
          SendPhytoToCustomerDate: doc?.SendPhytoToCustomerDate
            ? doc?.SendPhytoToCustomerDate
            : null,
          SendPhytoToCustomerTime: doc?.SendPhytoToCustomerTime
            ? doc?.SendPhytoToCustomerTime
            : null,
          RemarkLogStatus: doc?.RemarkLogStatus ? doc?.RemarkLogStatus : "",
          Shipper: doc?.Shipper ? doc?.Shipper : "",
          Consignee: doc?.Consignee ? doc?.Consignee : "",
          NotifyParty: doc?.NotifyParty ? doc?.NotifyParty : "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          const body = {
            DocumentStatus: values.DocumentStatus,
            SaleOrderId: id,
            ReceiveSIDate: values.ReceiveSIDate,
            ReceiveSITime: values.ReceiveSITime,
            ReviseSIDate: values.ReviseSIDate,
            ReviseSITime: values.ReviseSITime,
            SubmitSIDate: values.SubmitSIDate,
            SubmitSITime: values.SubmitSITime,
            DraftSI: receiveSI?.map((x) => ({
              ReceiveDate: x?.Receivedete,
              ReceiveTime: x?.Receivetime,
            })),
            DraftBL: receive?.map((x) => ({
              ReceiveDate: x?.dateSi,
              ReceiveTime: x?.timeSi,
              ReviseDate: x?.Receivedete,
              ReviseTime: x?.Receivetime,
            })),
            ConfirmSIDate: values.ConfirmSIDate,
            ConfirmSITime: values.ConfirmSITime,
            SubmitPhytoDate: values.SubmitPhytoDate,
            SubmitPhytoTime: values.SubmitPhytoTime,
            DraftPhyto: receivept?.map((x) => ({
              ReceiveDate: x?.datephyto,
              ReceiveTime: x?.timephyto,
              ReviseDate: x?.Receivedete,
              ReviseTime: x?.Receivetime,
            })),
            ConfirmPhytoDate: values.ConfirmPhytoDate,
            ConfirmPhytoTime: values.ConfirmPhytoTime,
            ReceiveInvoiceDate: values.ReceiveInvoiceDate,
            ReceiveInvoiceTime: values.ReceiveInvoiceTime,
            SendInvoiceToAccountingDate: values.SendInvoiceToAccountingDate,
            SendInvoiceToAccountingTime: values.SendInvoiceToAccountingTime,
            PickupBLDate: values.PickupBLDate,
            PickupBLTime: values.PickupBLTime,
            ReceiveBLDate: values.ReceiveBLDate,
            ReceiveBLTime: values.ReceiveBLTime,
            SendBLToCustomerDate: values.SendBLToCustomerDate,
            SendBLToCustomerTime: values.SendBLToCustomerTime,
            SendPhytoToCustomerDate: values.SendPhytoToCustomerDate,
            SendPhytoToCustomerTime: values.SendPhytoToCustomerTime,
            Shipper: values.Shipper,
            Consignee: values.Consignee,
            NotifyParty: values.NotifyParty,
            RemarkLogStatus: remarklog,
            RemarkType: remarkType,
          };

          const postDoc = async () => {
            const res = await api.post(`api/saleorder/update/document`, body);
            if (res.meta.status) {
              Swal.fire({
                title: `${res.meta.message}`,
                icon: "success",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
              }).then((result) => {
                if (result.isConfirmed) {
                  setSubmitting(false);
                }
              });
            }
          };
          postDoc();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              sx={{
                width: "100%",
                marginTop: "10px",
                paddingBottom: "24px",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: "500",

                    marginBottom: "10px",
                  }}
                >
                  Complete
                </Typography>
                <FormControl style={{ marginTop: "10px" }} fullWidth>
                  <InputLabel id="select_status-label">Status</InputLabel>
                  <Select
                    id="Status"
                    label="Status"
                    name="DocumentStatus"
                    InputLabelProps={{ shrink: true }}
                    value={values.DocumentStatus}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    sx={{
                      width: "30%",
                      marginBottom: "10px",
                    }}
                  >
                    <MenuItem value={1}>Complete</MenuItem>
                    <MenuItem value={0}>Not Complete</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  marginTop: "20px",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: "24px" }}>SI</Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Shipper"
                      variant="outlined"
                      placeholder="Shipper"
                      name="Shipper"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.Shipper}
                      // onChange={(e) => setFieldValue('SendPhytoToCustomerTime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Consignee"
                      variant="outlined"
                      placeholder="Consignee"
                      name="Consignee"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.Consignee}
                      // onChange={(e) => setFieldValue('SendPhytoToCustomerTime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="NotifyParty"
                      variant="outlined"
                      placeholder="NotifyParty"
                      name="NotifyParty"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.NotifyParty}
                      // onChange={(e) => setFieldValue('SendPhytoToCustomerTime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={6}>
                    <Typography>Receive SI</Typography>
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Receive SI"
                      inputFormat="dd/MM/yyyy"
                      value={values.ReceiveSIDate}
                      onChange={(e) =>
                        setFieldValue(
                          "ReceiveSIDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label=" Receive SI"
                      variant="outlined"
                      placeholder=" Receive SI"
                      type="time"
                      name="ReceiveSITime"
                      value={values.ReceiveSITime}
                      // onChange={(e) => setFieldValue('ReviseSITime', e)}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      type="button"
                      variant="contained"
                      style={{
                        background: "#80c340",
                        borderColor: "#80c340",
                        marginTop: "10px",
                      }}
                      onClick={() => setOpenAmendment(true)}
                    >
                      <AddIcon /> Amendment Draft SI
                    </Button>
                    {receiveSI?.length > 0 ? (
                      <TableContainer
                        sx={{
                          marginTop: 2,
                          marginBottom: 2,
                          maxWidth: "800px",
                        }}
                      >
                        <Table stickyHeader>
                          <TableRow>
                            <TableCell align="center">#</TableCell>
                            <TableCell align="center">
                              Receive SI Date time{" "}
                            </TableCell>

                            <TableCell align="center"></TableCell>
                          </TableRow>
                          {receiveSI?.map((data, index) => {
                            console.log(data);
                            return (
                              <TableBody>
                                <TableCell align="center">
                                  {index + 1}
                                </TableCell>

                                <TableCell align="center">
                                  {data?.Receivedete
                                    ? moment(data?.Receivedete).format(
                                        "yyyy/MM/DD"
                                      )
                                    : ""}{" "}
                                  {data?.Receivetime}
                                </TableCell>

                                <TableCell align="right">
                                  <Button
                                    onClick={() =>
                                      handleEditSI({
                                        id: index,
                                        ...data,
                                      })
                                    }
                                    variant="contained"
                                    style={{
                                      marginLeft: "15px",
                                      background: "#80c340",
                                      borderColor: "#80c340",
                                    }}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    style={{
                                      marginLeft: "15px",
                                      borderColor: "#80c340",
                                      color: "#80c340",
                                    }}
                                    onClick={() => delete_SI(index)}
                                  >
                                    Delete
                                  </Button>
                                </TableCell>
                              </TableBody>
                            );
                          })}
                        </Table>
                      </TableContainer>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid item xs={6}>
                    <Typography>Submit SI</Typography>
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Submit Date"
                      inputFormat="dd/MM/yyyy"
                      value={values.SubmitSIDate}
                      onChange={(e) =>
                        setFieldValue(
                          "SubmitSIDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      label=" Submit Time"
                      variant="outlined"
                      placeholder=" Submit Time"
                      type="time"
                      name="SubmitSITime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.SubmitSITime}
                      // onChange={(e) => setFieldValue('SubmitSITime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={12}>
                    <Button
                      type="button"
                      variant="contained"
                      style={{
                        background: "#80c340",
                        borderColor: "#80c340",
                        marginTop: "10px",
                      }}
                      onClick={() => setOpen(true)}
                    >
                      <AddIcon /> Amendment Draft Bl
                    </Button>
                    {receive?.length > 0 ? (
                      <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                        <Table stickyHeader>
                          <TableRow>
                            <TableCell align="center">#</TableCell>
                            <TableCell align="center">
                              Receive SI Date time{" "}
                            </TableCell>
                            <TableCell align="center">
                              Receive Date time
                            </TableCell>

                            <TableCell align="center"></TableCell>
                          </TableRow>
                          {receive?.map((data, index) => {
                            return (
                              <TableBody>
                                <TableCell align="center">
                                  {index + 1}
                                </TableCell>
                                <TableCell align="center" width="25%">
                                  {data?.dateSi
                                    ? moment(data?.dateSi).format("yyyy/MM/DD")
                                    : ""}{" "}
                                  {data?.timeSi}
                                </TableCell>
                                <TableCell align="center">
                                  {data?.Receivedete
                                    ? moment(data?.Receivedete).format(
                                        "yyyy/MM/DD"
                                      )
                                    : ""}{" "}
                                  {data?.Receivetime}
                                </TableCell>

                                <TableCell align="right">
                                  <Button
                                    onClick={() =>
                                      handleEdit({
                                        id: index,
                                        ...data,
                                      })
                                    }
                                    variant="contained"
                                    style={{
                                      marginLeft: "15px",
                                      background: "#80c340",
                                      borderColor: "#80c340",
                                    }}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    style={{
                                      marginLeft: "15px",
                                      borderColor: "#80c340",
                                      color: "#80c340",
                                    }}
                                    onClick={() => delete_mt_stel(index)}
                                  >
                                    Delete
                                  </Button>
                                </TableCell>
                              </TableBody>
                            );
                          })}
                        </Table>
                      </TableContainer>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid item xs={6}>
                    <Typography>Confirm Final Draft BL</Typography>
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Date"
                      inputFormat="dd/MM/yyyy"
                      value={values.ConfirmSIDate}
                      onChange={(e) =>
                        setFieldValue(
                          "ConfirmSIDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Time"
                      variant="outlined"
                      placeholder="Time"
                      type="time"
                      name="ConfirmSITime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.ConfirmSITime}
                      // onChange={(e) => setFieldValue('ConfirmSITime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}></Grid>

                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        marginBottom: "24px",
                        marginTop: "24px",
                        fontSize: "24px",
                      }}
                    >
                      Phyto
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>Submit Phyto</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography></Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Date"
                      inputFormat="dd/MM/yyyy"
                      value={values.SubmitPhytoDate}
                      onChange={(e) =>
                        setFieldValue(
                          "SubmitPhytoDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Time"
                      variant="outlined"
                      placeholder="Time"
                      type="time"
                      name="SubmitPhytoTime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.SubmitPhytoTime}
                      // onChange={(e) => setFieldValue('SubmitPhytoTime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={12}>
                    <Button
                      type="button"
                      variant="contained"
                      style={{
                        background: "#80c340",
                        borderColor: "#80c340",
                        marginTop: "10px",
                      }}
                      onClick={() => setOpenphyto(true)}
                    >
                      <AddIcon /> Amend Draft Phyto
                    </Button>
                    {receivept?.length > 0 ? (
                      <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                        <Table stickyHeader>
                          <TableRow>
                            <TableCell align="center">#</TableCell>
                            <TableCell align="center">
                              Receive Phyto Date time{" "}
                            </TableCell>
                            <TableCell align="center">
                              Receive Date time
                            </TableCell>

                            <TableCell align="center"></TableCell>
                          </TableRow>
                          {receivept?.map((data, index) => {
                            return (
                              <TableBody>
                                <TableCell align="center">
                                  {index + 1}
                                </TableCell>
                                <TableCell align="center" width="25%">
                                  {data?.datephyto
                                    ? moment(data?.datephyto).format(
                                        "yyyy/MM/DD"
                                      )
                                    : ""}{" "}
                                  {data?.timephyto}
                                </TableCell>
                                <TableCell align="center">
                                  {data?.Receivedete
                                    ? moment(data?.Receivedete).format(
                                        "yyyy/MM/DD"
                                      )
                                    : ""}{" "}
                                  {data?.Receivetime}
                                </TableCell>

                                <TableCell align="right">
                                  <Button
                                    onClick={() =>
                                      handleEditPT({
                                        id: index,
                                        ...data,
                                      })
                                    }
                                    variant="contained"
                                    style={{
                                      marginLeft: "15px",
                                      background: "#80c340",
                                      borderColor: "#80c340",
                                    }}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    style={{
                                      marginLeft: "15px",
                                      borderColor: "#80c340",
                                      color: "#80c340",
                                    }}
                                    onClick={() => deletephyto(index)}
                                  >
                                    Delete
                                  </Button>
                                </TableCell>
                              </TableBody>
                            );
                          })}
                        </Table>
                      </TableContainer>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>Confirm Final Phyto</Typography>
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Date"
                      inputFormat="dd/MM/yyyy"
                      value={values.ConfirmPhytoDate}
                      onChange={(e) =>
                        setFieldValue(
                          "ConfirmPhytoDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label=" Time"
                      variant="outlined"
                      placeholder="Time"
                      type="time"
                      name="ConfirmPhytoTime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.ConfirmPhytoTime}
                      // onChange={(e) => setFieldValue('ConfirmSITime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={6}></Grid>

                  {/* <Grid item xs={6}>
                    <Typography>Receive Invoice</Typography>
                  </Grid>
                  <Grid item xs={6}>
                  </Grid> */}

                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        marginBottom: "24px",
                        marginTop: "24px",
                        fontSize: "24px",
                      }}
                    >
                      Payment
                    </Typography>
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Receive Invoice"
                      inputFormat="dd/MM/yyyy"
                      value={values.ReceiveInvoiceDate}
                      onChange={(e) =>
                        setFieldValue(
                          "ReceiveInvoiceDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Receive Invoice"
                      variant="outlined"
                      placeholder="Receive Invoice"
                      type="time"
                      name="ReceiveInvoiceTime"
                      value={values.ReceiveInvoiceTime}
                      // onChange={(e) => setFieldValue('ReviseSITime', e)}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label=" Accounting Date"
                      inputFormat="dd/MM/yyyy"
                      value={values.SendInvoiceToAccountingDate}
                      onChange={(e) =>
                        setFieldValue(
                          "SendInvoiceToAccountingDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label=" Accounting Time"
                      variant="outlined"
                      placeholder=" Accounting Time"
                      type="time"
                      name="SendInvoiceToAccountingTime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.SendInvoiceToAccountingTime}
                      // onChange={(e) => setFieldValue('SendInvoiceToAccountingTime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  {/* <Grid item xs={3}></Grid>
                  <Grid item xs={3}></Grid> */}
                  <Grid item xs={6}>
                    <Typography>Pickup OBL</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>Receive OBL</Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Date"
                      inputFormat="dd/MM/yyyy"
                      value={values.PickupBLDate}
                      onChange={(e) =>
                        setFieldValue(
                          "PickupBLDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="TIME"
                      variant="outlined"
                      placeholder="TIME"
                      type="time"
                      name="PickupBLTime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.PickupBLTime}
                      // onChange={(e) => setFieldValue('PickupBLTime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Date"
                      inputFormat="dd/MM/yyyy"
                      value={values.ReceiveBLDate}
                      onChange={(e) =>
                        setFieldValue(
                          "ReceiveBLDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Time"
                      variant="outlined"
                      placeholder="Time"
                      type="time"
                      name="ReceiveBLTime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.ReceiveBLTime}
                      // onChange={(e) => setFieldValue('ReceiveBLTime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        marginBottom: "24px",
                        marginTop: "24px",
                        fontSize: "24px",
                      }}
                    >
                      Send To Customer
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>BL</Typography>
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Date"
                      inputFormat="dd/MM/yyyy"
                      value={values.SendBLToCustomerDate}
                      onChange={(e) =>
                        setFieldValue(
                          "SendBLToCustomerDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      name="BL"
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="TIME"
                      variant="outlined"
                      placeholder="BL TIME"
                      type="time"
                      name="SendBLToCustomerTime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.SendBLToCustomerTime}
                      // onChange={(e) => setFieldValue('SendBLToCustomerTime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={6}>
                    <Typography>Phyto</Typography>
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={3}>
                    <DesktopDatePicker
                      label="Date"
                      inputFormat="dd/MM/yyyy"
                      value={values.SendPhytoToCustomerDate}
                      onChange={(e) =>
                        setFieldValue(
                          "SendPhytoToCustomerDate",
                          moment(e).format("yyyy-MM-DD")
                        )
                      }
                      name="Phyto Time"
                      renderInput={(params) => (
                        <TextField sx={{ width: "100%" }} {...params} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="TIME"
                      variant="outlined"
                      placeholder="TIME"
                      type="time"
                      name="SendPhytoToCustomerTime"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.SendPhytoToCustomerTime}
                      // onChange={(e) => setFieldValue('SendPhytoToCustomerTime', moment(e).format('yyyy-MM-DD'))}
                      style={{ width: "100%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}></Grid>

                 
                </Grid>
              </Box>
            </Box>
            <div style={{ display: "flex", marginTop: 10 }}>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  color: "#FFF",
                }}
                onClick={() => setDiremark(true)}
                // type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </div>

            <Dialog fullWidth="sm" open={diremark}>
              <Box></Box>
              <DialogTitle>Remark</DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      style={{ marginTop: "5px" }}
                      autoFocus
                      name="RemarkLog"
                      label="Remark"
                      fullWidth
                      color="success"
                      variant="outlined"
                      onChange={(r) => setremarkLog(r.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Remark Option</InputLabel>
                      <Select
                        name="RemarkType"
                        label="Remark Type"
                        value={remarkType}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => setremarkType(e.target.value)}
                        MenuProps={{
                          style: {
                            maxHeight: 400,
                          },
                        }}
                        // disabled={values.inco_terms ? true : false}
                      >
                        {["Status Bill of Lading", "Status Phyto"].map(
                          (option, index) => {
                            return (
                              <MenuItem key={index} value={option}>
                                {option}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <DialogActions
                  sx={{
                    marginTop: "24px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <form onSubmit={() => setDiremark(false)}>
                    <Button
                      type="button"
                      variant="outlined"
                      style={{
                        color: "#80c340",
                        borderColor: "#80c340",
                        marginRight: "10px",
                      }}
                      onClick={handleCloseremark}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      type="submit"
                      style={{
                        background: remarklog ? "#80c340" : "gray",
                        borderColor: "#80c340",
                        marginRight: "10px",
                        color: "#FFF",
                      }}
                      disabled={!remarklog ? true : false}
                    >
                      Submit
                    </Button>
                  </form>
                </DialogActions>
              </DialogContent>
            </Dialog>
          </form>
        )}
      </Formik>
      <Dialog
        open={openphyto}
        maxWidth="lg"
        fullWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>ADD Phyto</DialogTitle>
        <Box></Box>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={6}>
              <Typography>Receive Draft Phyto</Typography>
            </Grid>
            <Grid item md={6}>
              <Typography>Amend Draft Phyto</Typography>
            </Grid>
            <Grid item md={3}>
              <DesktopDatePicker
                label="Phyto Date"
                inputFormat="dd/MM/yyyy"
                name="Phyto Date"
                value={datephyto}
                onChange={(e) => setphyto(moment(e).format("yyyy-MM-DD"))}
                renderInput={(params) => (
                  <TextField xsx={{ width: "100%" }} {...params} />
                )}
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                label="Phyto TIME"
                variant="outlined"
                placeholder="Phyto TIME"
                type="time"
                value={timephyto}
                onChange={(e) => settimephyto(e.target.value)}
                style={{ width: "100%", marginRight: 5 }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item md={3}>
              <DesktopDatePicker
                label="Receive Date"
                inputFormat="dd/MM/yyyy"
                name="Receive Date"
                value={Receivedete}
                onChange={(e) => setReceivedate(moment(e).format("yyyy-MM-DD"))}
                renderInput={(params) => (
                  <TextField sx={{ width: "100%" }} {...params} />
                )}
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                label="Receive TIME"
                variant="outlined"
                placeholder="Phyto TIME"
                type="time"
                value={Receivetime}
                onChange={(e) => setReceivetime(e.target.value)}
                style={{ width: "100%", marginRight: 5 }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
              color: "#ffff",
            }}
            onClick={handleaddpt}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAmendment}
        maxWidth="lg"
        fullWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>ADD Amendment Draft SI</DialogTitle>
        <Box></Box>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={6}>
              <Typography>Receive SI</Typography>
            </Grid>
            <Grid item md={6}></Grid>

            <Grid item xs={3}>
              <DesktopDatePicker
                label="Revise SI"
                inputFormat="dd/MM/yyyy"
                value={ReceivedeteSI}
                onChange={(e) =>
                  setReceivedateSI(moment(e).format("yyyy-MM-DD"))
                }
                renderInput={(params) => (
                  <TextField sx={{ width: "100%" }} {...params} />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Revise Time"
                variant="outlined"
                placeholder="Revise Time"
                name="ReviseSITime"
                type="time"
                value={ReceivetimeSI}
                onChange={(e) => setReceivetimeSI(e.target.value)}
                style={{ width: "100%", marginRight: 5 }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseSI}
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
              color: "#ffff",
            }}
            onClick={handleaddSi}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        maxWidth="lg"
        fullWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Draft BL</DialogTitle>
        <Box></Box>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={6}>
              <Typography>Receive Draft BL</Typography>
            </Grid>
            <Grid item md={6}>
              <Typography>Amend Draft BL</Typography>
            </Grid>
            <Grid item md={3}>
              <DesktopDatePicker
                label="Date"
                inputFormat="dd/MM/yyyy"
                name="PhytoDate"
                value={dateSi}
                onChange={(e) => setdateSi(moment(e).format("yyyy-MM-DD"))}
                renderInput={(params) => (
                  <TextField xsx={{ width: "100%" }} {...params} />
                )}
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                label="TIME"
                variant="outlined"
                placeholder="TIME"
                type="time"
                value={timeSi}
                onChange={(e) => settimeSi(e.target.value)}
                style={{ width: "100%", marginRight: 5 }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item md={3}>
              <DesktopDatePicker
                label="Date"
                inputFormat="dd/MM/yyyy"
                name="ReceiveDate"
                value={Receivedete}
                onChange={(e) => setReceivedate(moment(e).format("yyyy-MM-DD"))}
                renderInput={(params) => (
                  <TextField sx={{ width: "100%" }} {...params} />
                )}
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                label="TIME"
                variant="outlined"
                placeholder="TIME"
                type="time"
                value={Receivetime}
                onChange={(e) => {
                  setReceivetime(e.target.value);
                }}
                style={{ width: "100%", marginRight: 5 }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
              color: "#ffff",
            }}
            onClick={handleadd}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
